module.exports = __webpack_public_path__ + "img/triangle4blue.9ba60601.png";